import { Injectable } from '@angular/core';
import { Firestore } from '@angular/fire/firestore';
import { DEFAULT_DATE_PROPERTIES, defaultFirestoreConverter } from '../../core/db/firestore.helper';
import { FirestoreBase } from '../db/firestore-base';
import { ShippingBalancerByZone } from './settings-models';
import { SettingsType } from './settings.models';

export const shippingBalancerByZoneFirestoreConverter = defaultFirestoreConverter<ShippingBalancerByZone>(
  [...DEFAULT_DATE_PROPERTIES, 'balanceUpdatedAt']
);

@Injectable({
  providedIn: 'root'
})
export class SettingsDbService extends FirestoreBase<SettingsType> {

  constructor(firestore: Firestore) {
    super(
      'settings',
      firestore,
      { allowGetAll: true, dateProperties: ['expiresAt', 'syncdAt', 'lastTrackingUpdate'] },
    );
  }
}

